import { useEffect, useRef, useState } from 'react';

type HookOptions = {
  isEnabled?: boolean;
};

export default function useIntersectionObserver({ isEnabled = true }: HookOptions = {}) {
  const rootRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);

  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const $target = targetRef.current;

    if (!isEnabled || !$target) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      { root: rootRef.current }
    );

    observer.observe($target);

    return () => {
      observer.disconnect();
    };
  }, [isEnabled]);

  return { rootRef, targetRef, isIntersecting };
}
